import type { ExportDestinationContent } from '@capture/shared';
import { EXPORT_ADAPTER_TYPES } from '@capture/shared';

/** Adapter dropdown options — derived from the canonical `EXPORT_ADAPTERS`
 *  registry in @capture/shared so the dropdown, the API route's valid-adapter
 *  gate, and the `ExportDestinationContent['adapter']` union can't drift. */
export const ADAPTER_OPTIONS: ExportDestinationContent['adapter'][] = EXPORT_ADAPTER_TYPES;

/** Single source of truth for the format dropdown options. Mirrors the
 *  `format` literal union in `ExportDestinationContent`. (#49 dedup) */
export const FORMAT_OPTIONS: ExportDestinationContent['format'][] = [
  'csv',
  'fixed-width',
  'xml',
  'json',
];

/**
 * Common IANA timezone options for cron scheduling inputs (SchedulePanel,
 * TriggerPolicyPanel). Listed by hand; anchored to North-American business
 * hours. Keep this short — `Intl.supportedValuesOf('timeZone')` is too large
 * for a dropdown.
 */
export const TIMEZONE_OPTIONS: { value: string; label: string }[] = [
  { value: 'UTC', label: 'UTC' },
  { value: 'America/New_York', label: 'America/New_York (Eastern)' },
  { value: 'America/Chicago', label: 'America/Chicago (Central)' },
  { value: 'America/Denver', label: 'America/Denver (Mountain)' },
  { value: 'America/Los_Angeles', label: 'America/Los_Angeles (Pacific)' },
  { value: 'America/Anchorage', label: 'America/Anchorage (Alaska)' },
  { value: 'Pacific/Honolulu', label: 'Pacific/Honolulu (Hawaii)' },
  { value: 'Europe/London', label: 'Europe/London' },
  { value: 'Europe/Berlin', label: 'Europe/Berlin' },
  { value: 'Asia/Tokyo', label: 'Asia/Tokyo' },
];

/**
 * Shared cadence vocabulary for cron scheduling inputs (SchedulePanel,
 * TriggerPolicyPanel, and analytics' saved-report SchedulePanel — Task 8,
 * S-2). Single source of truth so a preset added here reaches every
 * schedule editor instead of drifting between hand-copies.
 */
export const DEFAULT_CRON = '0 17 * * *';

export const CRON_PRESETS: { label: string; cron: string }[] = [
  { label: 'Every 15 min', cron: '*/15 * * * *' },
  { label: 'Hourly', cron: '0 * * * *' },
  { label: 'Daily at 5 PM', cron: '0 17 * * *' },
  { label: 'Weekly Mon 8 AM', cron: '0 8 * * 1' },
];
